import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

interface Props {
  motivo?: string | null;
  fecha?: string | null;
  usuario?: string | null;
}

export const CancelMotiveCard = ({ motivo, fecha, usuario }: Props) => (
  <Flex flexDir="column" gap="8px">
    <Text fontWeight={700}>Motivo de cancelación</Text>
    <Flex flexDir="column" paddingX="24px" borderLeft={`4px solid ${AppColors.WHITE_BORDER_1}`}>
      <Text fontWeight={400}>{motivo}</Text>
      <Text fontWeight={400} fontSize="12px" color={AppColors.GRAY_TEXT}>
        {fecha
          ? dayjs.utc(fecha).tz("America/Argentina/Buenos_Aires").format("DD/MM/YYYY - HH:mm")
          : "-"}{" "}
        - {usuario ?? "-"}
      </Text>
    </Flex>
  </Flex>
);
